<template>
  <div class="ax-step-box">
    <div class="step-box">
      <div class="step-top" :class="statusTemp[data.action_type]">
        <div class="status"></div>
        <div class="status-text">【{{ data.action_title }}】</div>
      </div>
      <div class="step-content">
        <div class="details">
          <div class="details-l">
            <h6 v-if="data.user_name">
              {{ data.user_name }} <span>审批人</span>
            </h6>
            <p>{{ data.approve_date }}</p>
          </div>
          <div
            class="details-r"
            @click="collapse"
            v-if="
              data.comment_text &&
                data.comment_text !== '' &&
                data.comment_text !== '无'
            "
          >
            审批意见
            <van-icon :class="active ? 'icon_active' : ''" name="arrow" />
          </div>
        </div>
        <div class="contents" ref="content">
          <p
            v-if="
              data.comment_text &&
                data.comment_text !== '' &&
                data.comment_text !== '无'
            "
          >
            {{ data.comment_text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ax-step",
  props: {
    data: [Object],
  },
  data() {
    return {
      timer: null,
      active: true,
      statusTemp: {
        "-1": "block_refuse",
        "1": "block_agree",
        "3": "block_reject",
        "5": "block_agree",
        "0": "block_reject",
        "6": "block_reject",
      },
      activeNames: [],
    };
  },
  methods: {
    collapse() {
      this.active = !this.active;
      let height = this.$refs.content.getBoundingClientRect().height;
      if (!!height) {
        this.$refs.content.style.height = height + "px";
        var f = document.body.offsetHeight;
        this.$refs.content.style.height = "0px";
      } else {
        this.$refs.content.style.height = "auto";
        height = this.$refs.content.getBoundingClientRect().height;
        this.$refs.content.style.height = "0";
        var f = document.body.offsetHeight;
        this.$refs.content.style.height = height + "px";
        var _this = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          _this.$refs.content.style = null;
        }, 300);
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.ax-step-box {
  width: 100%;
  &:last-child {
    .step-box {
      border-color: transparent;
    }
  }
  .step-box {
    .step-top {
      &.block_agree {
        .status {
          background-color: $link-a;
        }
        .status-text {
          color: $link-a;
        }
      }
      &.block_reject {
        .status {
          background-color: $reject-color;
        }
        .status-text {
          color: $reject-color;
        }
      }
      &.block_refuse {
        .status {
          background-color: $refuse-color;
        }
        .status-text {
          color: $refuse-color;
        }
      }
    }
  }
  .step-box {
    margin-left: 22px;
    padding-bottom: 11px;
    padding: 0 12px 12px 15px;
    border-left: 0.053333333rem solid #e8e8e8;
    position: relative;
    border-top: 1px solid #fff;
    .step-top {
      height: 24px;
      .status {
        width: 12px;
        height: 12px;
        background-color: #e8e8e8;
        border-radius: 50%;
        position: absolute;
        left: -7px;
        top: 0;
      }
      .status-text {
        margin-top: -6px;
        font-size: 17px;
        color: #333;
        line-height: 24px;
        text-indent: -0.5em;
      }
    }
    .step-content {
      .details {
        display: flex;
        align-items: center;
        padding-top: 8px;
        .details-l {
          flex: 1;
          h6 {
            font-size: 16px;
            color: #333;
            font-weight: inherit;
            line-height: 22px;
            span {
              background: rgba(0, 0, 0, 0.1);
              border-radius: 4px;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.3);
              padding: 1px 5px;
            }
          }
          p {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.3);
            line-height: 20px;
          }
        }
        .details-r {
          display: flex;
          align-items: center;
          font-size: 17px;
          color: #576b95;
          .van-icon {
            color: rgba(0, 0, 0, 0.9);
            margin-left: 8px;
            font-size: 16px;
            -webkit-transition: -webkit-transform 0.3s
              cubic-bezier(0.86, 0, 0.07, 1);
            transition: -webkit-transform 0.3s cubic-bezier(0.86, 0, 0.07, 1);
            transition: transform 0.3s cubic-bezier(0.86, 0, 0.07, 1);
            transition: transform 0.3s cubic-bezier(0.86, 0, 0.07, 1),
              -webkit-transform 0.3s cubic-bezier(0.86, 0, 0.07, 1);
            &.icon_active {
              transform: rotate(90deg);
            }
          }
        }
      }
      .contents {
        display: block;
        transition: height 0.3s;
        -webkit-transition: height 0.3s;
        margin-top: 17px;
        overflow: hidden;
        p {
          font-size: 15px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
}
</style>
